import { UserRolesEnum } from 'commons/types/user.roles.enum';
import {
  HOME_ROUTES,
  INBOUND_ROUTES,
  PACK_TASK_ROUTES,
  PICK_TASK_ROUTES,
} from 'routes/constants';

// to determine default root url
export const getRootUrl = (activeRole?: UserRolesEnum | null): string => {
  switch (activeRole) {
    case UserRolesEnum.PICKER:
    case UserRolesEnum.PICKER_LEAD:
    case UserRolesEnum.PICKER_SPV:
      return PICK_TASK_ROUTES.ASSIGN;
    case UserRolesEnum.PACKER:
    case UserRolesEnum.PACKER_LEAD:
    case UserRolesEnum.PACKER_SPV:
      return PACK_TASK_ROUTES.CHECK_BASKET;
    case UserRolesEnum.ADMIN:
    case UserRolesEnum.SUPER_ADMIN:
    case UserRolesEnum.REPLENISH:
      return HOME_ROUTES.HOME_PAGE;
    case UserRolesEnum.APJ:
      return INBOUND_ROUTES.APPROVAL_LIST;
    default:
      return !activeRole ? HOME_ROUTES.HOME_PAGE : '/not-found';
  }
};
